import React from 'react'
import { CCard, CCardHeader, CCol, CRow } from '@coreui/react-pro'
import ReportForm from 'components/Report/ReportForm'

function ReportCreate() {
  return (
    <CRow>
      <CCol xs={12}>
        <CCard>
          <CCardHeader>
            <strong>Formulário</strong> <small>Importação</small>
          </CCardHeader>
          <ReportForm />
        </CCard>
      </CCol>
    </CRow>
  )
}

export default ReportCreate
